import { Component, forwardRef } from 'react';
import { isNil } from 'lodash';

const appRoot = document.getElementById('app');

export default function withParentPosition(UnwrappedComponent) {
  class WithParentPosition extends Component {
    static defaultProps = {
      rootElement: appRoot,
      containerElement: document.createElement('div'),
    };

    getParentPosition = () => {
      // @ts-expect-error TS(2339): Property 'containerElement' does not exist on type... Remove this comment to see the full error message
      const { containerElement, rootElement } = this.props;

      if (!containerElement || isNil(rootElement)) {
        return {
          bottom: null,
          left: null,
          right: null,
          top: null,
          width: null,
        };
      }

      const appRect = rootElement.getBoundingClientRect();
      const { left: containerLeft, top: containerTop, height, width } = containerElement.getBoundingClientRect();

      const left = containerLeft - window.scrollX;

      const right = appRect.width - (containerLeft + width + window.scrollX);

      const bottom = containerTop + height + window.scrollY;

      const top = appRect.height - (containerTop + window.scrollY);

      return {
        bottom,
        left,
        right,
        top,
        width,
      };
    };

    render() {
      // @ts-expect-error TS(2339): Property 'forwardedRef' does not exist on type 'Re... Remove this comment to see the full error message
      const { forwardedRef, ...rest } = this.props;

      return <UnwrappedComponent {...rest} ref={forwardedRef} getParentPosition={this.getParentPosition} />;
    }
  }

  // @ts-expect-error TS(2769): No overload matches this call.
  return forwardRef((props, ref) => <WithParentPosition {...props} forwardedRef={ref} />);
}
